<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">{{(isEdit) ? 'Edit' : 'Add'}} Manufacturer</h3>
            </div>
            <v-form class="v-form-body" ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="6">
                  <label class="form-control-label">Name
                    <span class="red--text">*</span>
                  </label>
                  <v-text-field
                    v-model="name"
                    placeholder="Enter Manufacturer Name"
                    :rules="[(v) => !!v || 'Manufacturer Name is required!',(v) => v && !!v.trim() || 'Field cannot be blank']"
                    required
                    solo
                  ></v-text-field>
                </v-col>
                <v-col class="text-right" cols="12">
                  <v-btn
                    color="#989898"
                    class="mr-4 white--text"
                    @click="cancel"
                    >Cancel</v-btn
                  >
                  <v-btn
                    :disabled="!valid"
                    color="#344452"
                    class="white--text"
                    :loading="loading"
                    @click="validate"
                    >{{(isEdit) ? 'Update' : 'Save'}}</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import { ManufacturerService } from "@/services";

export default {
  name: "AddManufacturer",
  components: {
    CommonSection,
  },
  data() {
    return {
      loading: false,
      valid: true,
      name: null,
      isEdit: false
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      if (this.$route.params.id !== 'create') {
        this.isEdit = true;
        const manufacturerDetail = await ManufacturerService.get(
          this.$route.params.id
        );
        this.name = manufacturerDetail.data.data[0].name;
      }
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let response;
          if (this.$route.params.id !== 'create') {
            response = await ManufacturerService.update({
              id: this.$route.params.id,
              object: {
                name: this.name,
              },
            });
          } else {
            response = await ManufacturerService.create({
              name: this.name,
            });
          }
          this.loading = false;
          if (response) {
            this.$router.push("/manufacturer");
            this.$store.dispatch(
              "user/setSnack",
              `Manufacturer ${(this.isEdit) ? 'updated' : 'added'} successfully!`
            );
            this.$store.dispatch("user/setType", "info");
          }
        } catch (error) {
          this.$store.dispatch("user/setSnack", error);
          this.$store.dispatch("user/setType", "error");
          this.loading = false;
        }
      }
    },
    cancel() {
      this.$router.push("/manufacturer");
    },
  },
};
</script>